import logo from  "assets/images/tale3-logo.png"

export const AppLogo=()=>{
    return <>
        <div className="flex rounded-lg overflow-hidden  h-20 w-20 items-center justify-center  bg-primary">
            <img src={logo} alt="tale3-logo"  />
        </div>
    </>
}